import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Schweizerdeutsch",
  code: "de-CH",
  messages: {
    alert: {
      close: "Schliessen"
    },
    authForm: {
      hidePassword: "Passwort verbergen",
      showPassword: "Passwort anzeigen",
      submit: "Weiter"
    },
    banner: {
      close: "Schliessen"
    },
    calendar: {
      nextMonth: "N\xE4chster Monat",
      nextYear: "N\xE4chstes Jahr",
      prevMonth: "Vorheriger Monat",
      prevYear: "Vorheriges Jahr"
    },
    carousel: {
      dots: "Folie zur Anzeige ausw\xE4hlen",
      goto: "Gehe zu {slide}",
      next: "Weiter",
      prev: "Zur\xFCck"
    },
    chatPrompt: {
      placeholder: "Hier schreiben Sie Ihre Nachricht..."
    },
    chatPromptSubmit: {
      label: "Senden"
    },
    colorMode: {
      dark: "Dunkel",
      light: "Hell",
      switchToDark: "Zum dunklen Modus wechseln",
      switchToLight: "Zum hellen Modus wechseln",
      system: "System"
    },
    commandPalette: {
      back: "Zur\xFCck",
      close: "Schliessen",
      noData: "Keine Daten",
      noMatch: "Nichts gefunden",
      placeholder: "Geben Sie einen Befehl ein oder suchen Sie..."
    },
    contentSearch: {
      links: "Links",
      theme: "Thema"
    },
    contentSearchButton: {
      label: "Suchen..."
    },
    contentToc: {
      title: "Auf dieser Seite"
    },
    dashboardSearch: {
      theme: "Thema"
    },
    dashboardSearchButton: {
      label: "Suchen..."
    },
    dashboardSidebarCollapse: {
      collapse: "Seitenleiste einklappen",
      expand: "Seitenleiste erweitern"
    },
    dashboardSidebarToggle: {
      close: "Seitenleiste schliessen",
      open: "Seitenleiste \xF6ffnen"
    },
    error: {
      clear: "Zur\xFCck zur Startseite"
    },
    fileUpload: {
      removeFile: "{filename} entfernen"
    },
    header: {
      close: "Men\xFC schliessen",
      open: "Men\xFC \xF6ffnen"
    },
    inputMenu: {
      create: '"{label}" erstellen',
      noData: "Keine Daten",
      noMatch: "Nichts gefunden"
    },
    inputNumber: {
      decrement: "Verringern",
      increment: "Erh\xF6hen"
    },
    modal: {
      close: "Schliessen"
    },
    pricingTable: {
      caption: "Preisplanvergleich"
    },
    prose: {
      codeCollapse: {
        closeText: "Reduzieren",
        name: "Code",
        openText: "Erweitern"
      },
      collapsible: {
        closeText: "Ausblenden",
        name: "Eigenschaften",
        openText: "Anzeigen"
      },
      pre: {
        copy: "Code in die Zwischenablage kopieren"
      }
    },
    selectMenu: {
      create: '"{label}" erstellen',
      noData: "Keine Daten",
      noMatch: "Nichts gefunden",
      search: "Suchen..."
    },
    slideover: {
      close: "Schliessen"
    },
    table: {
      noData: "Keine Daten"
    },
    toast: {
      close: "Schliessen"
    }
  }
});
